import { withPreview } from '../decorators/withPreview';
import { Textarea, TextareaProps } from './Textarea';
import TextCollapser from '../TextCollapser';
import React from 'react';
import { isNullOrUndefined } from '../../predicates/type';

export const TextareaWithPreview = withPreview<TextareaProps>(Textarea);

export const formatPreviewCollapsibleText = (props: TextareaProps, length = 160) => {
	if (isNullOrUndefined(props.value) || props.value === '') {
		return;
	}

	return (
		<TextCollapser
			value={props.value}
			length={length}
		/>
	);
};

export const formatPreviewInsertAsHTML = (props: TextareaProps) => {
	if (isNullOrUndefined(props.value) || props.value === '') {
		return;
	}

	return <div dangerouslySetInnerHTML={{ __html: props.value }} />;
};
